import {
    createProvider
} from 'react-redux';

export default createProvider('cmp_store');


// WEBPACK FOOTER //
// ./_source/cqsx/services/provider.js